<template>
  <div class="about">
    <section class="about__section" id="about">
      <h2 class="spacer">Portfolio</h2>
      
        <!-- <div class="about__description">
          <p>
            We are an engineering services and equipment provider based in
            Herefordshire and Kingstone in the West Midlands UK. We have over 20
            years experience of fabrication, machining and machine
            manufacturing; including extensive work for the rubber industry.
          </p>
          <br />
          <p>
            We offer planned maintenance contracts and onsite maintenance work,
            working with your operatives/engineers or on a job by job basis. We
            can fabricate side plates, head brackets and produce two position
            mounting brackets to fit to existing side casings for hydraulic
            hammers, and make stillage bases and large factory tables with mould
            racks underneath.
          </p>
          <br />
          <p>
            We also have a large stock of engineering equipment for sale,
            including fabrication and welding equipment, presses, punches, CNC
            machines and more. For more info contact us by phone or email using
            the buttons below.
          </p>

          <div class="contact__buttons">
            <a href="tel:01981251651"
              ><button class="contact__button">Phone</button></a
            >
            <a
              href="mailto:manumechltd@hotmail.com?subject=Manumech Website Enquiry"
              ><button class="contact__button">Email</button></a
            >
          </div>
        </div> -->
        <div class="about__images">
          <img src="@/images/about_images/maylor3.png" alt="" />
          <img src="@/images/about_images/maylor2.png" alt="" />
          <img src="@/images/about_images/maylor5.png" alt="" />
          <img src="@/images/about_images/maylor4.png" alt="" />
          

          <img src="@/images/about_images/maylor6.png" alt="" />
          <img src="@/images/about_images/maylor7.png" alt="" />
          <img src="@/images/about_images/maylor8.png" alt="" />
          <img src="@/images/about_images/maylor9.png" alt="" />

          <img src="@/images/about_images/maylor10.png" alt="" />
          <img src="@/images/about_images/maylor11.png" alt="" />
          <img src="@/images/about_images/maylor12.png" alt="" />
          <img src="@/images/about_images/maylor13.png" alt="" />

          <img src="@/images/about_images/maylor14.png" alt="" />
          <img src="@/images/about_images/maylor15.png" alt="" />
          <img src="@/images/about_images/maylor16.png" alt="" />
          <img src="@/images/about_images/maylor17.png" alt="" />

          <img src="@/images/about_images/maylor18.png" alt="" />
          <img src="@/images/about_images/maylor19.png" alt="" />
          <img src="@/images/about_images/maylor20.png" alt="" />
          <img src="@/images/about_images/maylor21.png" alt="" />

          <img src="@/images/about_images/maylor22.png" alt="" />
          <img src="@/images/about_images/maylor23.png" alt="" />
          <img src="@/images/about_images/maylor24.png" alt="" />
          <img src="@/images/about_images/maylor25.png" alt="" />

          <img src="@/images/about_images/maylor26.png" alt="" />
          <img src="@/images/about_images/maylor27.png" alt="" />
          <img src="@/images/about_images/maylor28.png" alt="" />
          <img src="@/images/about_images/maylor29.png" alt="" />

        </div>
      

      <!-- assets -->
      
      <img
        class="about__triangle__bottom__right"
        src="@/images/triangle-about-bottom-right.png"
        alt="triangle-shape"
      />
    </section>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
.spacer {
  margin-bottom: 30px;
}

.about {
  overflow: hidden;
}

.about__grid__container {
  display: grid;
  margin-top: 20px;
  grid-template-columns: 7fr 4fr;
  grid-gap: 40px;
  align-content: center;
  justify-items: center;
}


.about__images {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  /* grid-template-rows: auto auto; */
  grid-gap: 40px;
  margin-top: 20px;
 
  align-content: center;
  justify-items: center;
}

@media screen and (max-width: 1000px) {
  .about__grid__container {
    grid-template-columns: auto;
    grid-template-rows: auto;
    grid-gap: 0;
  }

  .about__description {
    grid-column: 1 / 4;
    grid-row: 1 / 1;
  }



  .about__images {
  /* display: grid; */
  grid-template-columns: repeat(4, minmax(0, 1fr));
  /* grid-template-columns: auto; */
  grid-gap: 15px;
  }
}

@media screen and (max-width: 600px) {
  .about__grid__container {
    grid-template-columns: auto;
    grid-template-rows: auto;
  }

  .about__description {
    grid-column: 1 / 1;
    grid-row: 1 / 1;
  }

  .about__images {
  /* display: grid; */
  /* grid-template-columns: repeat(2, minmax(0, 1fr)); */
  grid-template-columns: auto;
  padding: 10px 20px;

  }
  
}

.about__description p {
  color: #161521;
}


.about__images img {
  /* max-width: 100%; */
  width: 100%;
  /* border-radius: 10px; */
  box-shadow: 1px 1px 1px 0px rgba(76, 69, 105, 0.5);
}

.about__images img:first-of-type {
  border-top-left-radius: 0px;
}

.about__images img:last-of-type {
  border-bottom-right-radius: 0px;
}

.contact__buttons {
  margin-top: 30px;
}

.contact__buttons .contact__button {
  font-family: "PT Sans", sans-serif;
  font-size: 18px;
  text-decoration: none;
  padding: 8px 25px;
  background-color: #161521;
  border: 1px solid #ecf0f1;
  color: #ecf0f1;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  margin-right: 15px;
}

.contact__button:hover {
  border: 1px solid #161521;
  background-color: transparent;
  color: #161521;
  font-weight: bold;
}

.call__button {
  background-color: #161521;
  color: #161521;
  font-weight: bold;
}
</style>
